/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { compact } from '@linc-technologies/linced-common/utils/arrays';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';

export default class ApplicationsRoute extends Route {
  queryParams = {
    status: {
      refreshModel: true,
    },
  };

  // Services
  @service
  personOptions;

  @service
  session;

  @service
  store;

  model(params) {
    return hash({
      applications: this.store.query('enrolments/application', params),
      schemas: this.store.query('enrolments/schema', {
        schoolId: this.get('session.activeSchool'),
      }),
    });
  }

  setupController(controller, model) {
    super.setupController(...arguments);

    // Get the latest schema to work with
    let schema = model.schemas
      .slice()
      .sort((a, b) => a.createTime - b.createTime)
      .at(-1);
    // Get the sections of the schema
    let sections = schema.sections.slice();
    // Add extra sections from their own attributes in the schema (i.e. contacts)
    sections.push(...compact([schema.primaryContacts]));
    // We're cool kids who are using maps for quick and easy lookup of where each field is
    let sectionsAndFieldsByFieldIds = sections.reduce((map, section) => {
      section.fields.forEach((field) => {
        map[field.fieldId] = {
          section,
          field,
        };
      });
      return map;
    }, {});
    // Check if there are previously selected custom fields
    let fieldIds = this.personOptions.enrolmentApplicationsCustomFields;
    if (!isEmpty(fieldIds)) {
      // The user has previously selected custom fields - let's pull them back in
      fieldIds.forEach((fieldId, index) => {
        if (!sectionsAndFieldsByFieldIds[fieldId]) {
          // The field might have been removed.
          return;
        }
        let field = sectionsAndFieldsByFieldIds[fieldId].field;
        let section = sectionsAndFieldsByFieldIds[fieldId].section;
        controller.updateCustomFieldObjectAtIndex({ section, field }, index);
      });
    }

    // Update properties in the controller
    controller.setProperties({
      schema: schema,
      allSections: sections,
    });
  }
}
